<svelte:head>
  <title>{data?.name || 'Offer'} | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-missing-attribute -->

<div class="block is-size-7">
  <a href={$url('../../../offers')}> &lt; Back to offers</a>
</div>

{#if data}
  <nav class="level">
    <div class="level-left level-can-wrap">
      <div class="level-item level-can-wrap">
        <h2 class="title">
          {data.name || '<No name>'} <span class="tag is-info is-small">{data.status}</span>
        </h2>
      </div>
    </div>

    <!-- Right side -->
    <div class="level-right">

      {#if isAdmin}
      
        <button class="button" on:click={() => $goto('../edit')}> Edit </button>
        &nbsp;

        {#if company}
          <a
            class="button"
            href={$url('../../../charity', {
              filter_postcode: data.location.postcode
            })}>
            Show nearby charities
          </a>
          &nbsp;
        {/if}

        {#if data.status === 'pending-approval'}
          <button
            class="button is-primary"
            on:click={() =>
              ($uiState.activeModal = {
                component: ConfirmApprove,
                props: { item: { id, data } }
              })}>
            Approve
          </button>
          &nbsp;
        {/if}

        {#if data.status === 'published'}
          <button
            class="button"
            on:click={() => {
              $uiState.activeModal = {
                component: ResendOffer,
                props: { item: { id, data } }
              };
            }}>
            Resend
          </button>
          &nbsp;
        {/if}

        {#if data.status === 'published'}
          {#if !data.paused}
            <button
              class="button"
              on:click={() => {
                pauseOffer(true);
              }}>
              Pause
            </button>
            &nbsp;
          {:else}
            <button
              class="button"
              on:click={() => {
                pauseOffer(false);
              }}>
              Resume
            </button>
            &nbsp;
          {/if}

          <button
            class="button"
            on:click={() => {
              $uiState.activeModal = {
                component: ConfirmEnd,
                props: { item: { id, data } }
              };
            }}>
            End
          </button>
          &nbsp;
        {/if}

        {#if data.status === 'draft'}
          <button
            class="button"
            on:click={() => {
              $uiState.activeModal = {
                component: ConfirmDelete,
                props: { item: { data: data, id }, navPath }
              };
            }}>
            Delete
          </button>
          &nbsp;
        {/if}

      {/if}

      <!-- svelte-ignore a11y-missing-attribute -->
      <a
        class="button is-secondary"
        on:click={() => {
          showNotes = !showNotesPanel;
        }}
        ><span class="icon" class:has-text-info={showNotesPanel}>
          <i class="mdi mdi-message" />
        </span></a>
    </div>
  </nav>

  <div class="columns">
    <div class="column">

      <EditableTagList
        type=offer
        readonly={!isAdmin}
        bind:tags={data.tags}
        on:changed={() => {saveTags()}}/>

      {#if data.status === 'published' && data.paused}
        <article class="message is-danger">
          <div class="message-body">
            <p class="block">This offer is paused.</p>
          </div>
        </article>
      {:else if data.status === 'published'}
        <article class="message is-success">
          <div class="message-body">
            <p class="block">
              This offer is live! Public link:
              <a href="{$appState.origin}/public/offer/{id}"
                >{$appState.origin}/public/offer/{id}</a>
            </p>
          </div>
        </article>
      {/if}

      {#if data.status === 'ended'}
        <article class="message is-success">
          <div class="message-body">
            <p class="block">This offer has ended.</p>
          </div>
        </article>
      {/if}

      <div class="columns">

        <div class="column">
          {#if data.status === 'draft' || data.status === 'pending-approval'}
            <div class="block has-text-grey-light">Created {createdDatePhrase}</div>  
          {:else}
            <div class="block has-text-grey-light">Published {publishedDatePhrase}</div>  
          {/if}

          {#if data.location.postcode || data.options?.nationwide || data.options?.divisible}
            <div class="block">
              {#if data.location.postcode}
                <span class="tag is-light is-small"
                  >{data.location.postcode}</span>
              {/if}
              {#if data.options?.nationwide}
                <span class="tag is-info is-small"
                  >Offered nationwide via post</span>
              {/if}
              {#if data.options?.divisible}
                <span class="tag is-warning is-small">Can be split</span>
              {/if}
              {#if data.options?.large}
                <span class="tag is-danger is-small">Large offer</span>
              {/if}
            </div>
          {/if}

          <p class="block" style="white-space:pre-wrap;">{data.description}</p>
        </div>

        <div class="column is-narrow">
          {#if data.images?.[0]}
            <img
              alt="Offer"
              on:click={() => {
                $uiState.activeModal = {
                  component: Lightbox,
                  props: { images: data.images, index: 0 }
                };
              }}
              src={data.images[0]}
              style="width:240px; cursor:pointer;" />
          {:else}
            <img
              alt="Generic"
              src="/assets/img/box.png"
              style="height:240px;width:240px; background-color:lightgrey" />
          {/if}
          <div style="width:250px;">
            {#if data.images && data.images.length > 1}
              {#each data.images as url, index}
                {#if index !== 0}
                  <div style="display:inline-block;margin-right: 8px;">
                    <img
                      alt="Offer"
                      on:click={() => {
                        $uiState.activeModal = {
                          component: Lightbox,
                          props: { images: data.images, index }
                        };
                      }}
                      src={url}
                      style="max-width:116px;" />
                  </div>
                {/if}
              {/each}
            {/if}
          </div>
        </div>
      </div>

      {#if company}
        <hr />
        <h2 class="is-size-4">Business</h2>
        <div class="columns">
          <div class="column">
            <table class="table is-fullwidth">
               <tbody>
                {#if contact}
                  <tr>
                    <td>User</td>
                    <td
                      ><a href={$url('../../../user/' + contact.id)}
                        >{contact.data.firstName}
                        {contact.data.lastName}</a>
                    </td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>{contact.id}</td>
                  </tr>
                {/if}
                <tr>
                  <td>Company</td>
                  <td
                    ><a href={$url('../../../business/' + data.company)}
                      >{company.name}</a
                    ></td>
                </tr>
                <tr>
                  <td>Postcode</td>
                  <td>
                    {company.postcode}
                  </td>
                </tr>
                <tr>
                  <td>Subscription</td>
                  <td>
                    {#if hasActiveSubscription(company)}
                      <span class="tag is-success is-medium"
                        >Premium Access</span>
                    {:else}
                      None
                    {/if}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {#if data.location.point || (company && company.location)}
            <div class="column is-narrow">
              <div class="block" style="width:250px;">
                <Map location={data.location.point} drawCircle />
              </div>
            </div>
          {/if}
        </div>
      {/if}

      <hr />
      <h2 class="is-size-4">Requests</h2>
      <table class="table is-hoverable">
        <colgroup>
          <col span="1" style="width: 20%;" />
          <col span="1" style="width: 70%;" />
          <col span="1" style="width: 10%;" />
        </colgroup>
        <tbody>
          {#if requests}
            {#each requests as request}
              <tr>
                <td>
                  <span>
                    <a href={$url('../request/' + request.id)}>
                      {request.data.charity.name}
                    </a>
                  </span>
                </td>
                <td>
                  {#if request.data.message}
                    <Message>
                      {request.data.message.substring(0, 150)}
                      {#if request.data.message.length > 150}
                        ...
                      {/if}
                    </Message>
                  {/if}
                </td>
                <td>
                  {#if request.data.created}
                    <span
                      style="white-space:nowrap;"
                      class="has-text-grey-light">
                      {dayjs().to(request.data.created)}
                    </span>
                  {/if}
                </td>
                <td>
                  <RequestStatusTag status={request.data.status || 'new'} />
                </td>
              </tr>
            {/each}
          {/if}
        </tbody>
      </table>

      {#if !requests || requests.length == 0}
        <div class="block has-text-grey-light">
          Waiting for the first request for this offer.
        </div>
      {/if}
    </div>
    <div
      class="column is-4"
      class:is-hidden={!showNotesPanel}>
      <div class="box">
        <div class="block">Admin notes</div>
        <NoteList {id} objectType="offer" on:loaded={(ev) => { initialNoteCount = ev.detail.noteCount }} />
      </div>
    </div>
  </div>
{/if}

<script lang="ts">
  export let id: string;
  import _ from 'lodash';
  import { appState } from '../../../../lib/appState';
  import { uiState } from '../../../../lib/uiState';
  import { goto, url } from '@sveltech/routify';

  import Lightbox from '../../../_components/Lightbox.svelte';
  import Message from '../../../_components/Message.svelte';
  import ConfirmApprove from '../../offers/_components/ConfirmApprove.svelte';
  import ConfirmEnd from './_components/ConfirmEnd.svelte';
  import Map from '../../../_components/MapJS.svelte';
  import dayjs from 'dayjs';
  import relativeTime from 'dayjs/plugin/relativeTime';
  import { hasActiveSubscription } from '../../../../lib/subscriptionHelper';
  import ConfirmDelete from '../../../business/offer/[id]/_components/ConfirmDelete.svelte';
  import ResendOffer from './_components/ResendOffer.svelte';
  import RequestStatusTag from '../../../_components/RequestStatusTag.svelte';

  import NoteList from '../../_components/NoteList.svelte';
  import Published from "../../needs/published.svelte";

  import EditableTagList from '../../_components/EditableTagList.svelte';

  dayjs.extend(relativeTime);

  let data: Offer_v2;

  let company: Company_v1;
  let contact: User_v1_Doc;

  let showNotes: undefined | boolean;
  let initialNoteCount = 0;
  $: showNotesPanel = showNotes !== undefined ? showNotes : initialNoteCount > 0;

  $: isAdmin = $appState.user?.isFullAdmin || ($appState.user?.delegatedAdminTag !== undefined && company?.tags?.includes($appState.user.delegatedAdminTag));

  let firebase = window.firebase;

  const navPath = '/admin/offers/draft';

  $: createdDatePhrase = data?.created ? dayjs().to(data.created) : undefined;
  $: publishedDatePhrase = data?.published ? dayjs().to(data.published) : undefined;

  get();

  $: if (data) getCompany(data.company);

  $: if (data) getContact(data.company);

  async function get() {
    firebase
      .firestore()
      .collection('offers_v2')
      .doc(id)
      .onSnapshot((doc) => {
        data = doc.data() as Offer_v2;

        // backwards compat
        if(!data.tags) {
          data.tags = [];
        }
      });
  }

  let requests = [] as Request_v2_Doc[];

  getRequests();

  async function getRequests() {
    firebase
      .firestore()
      .collection('requests_v2')
      .where('offer', '==', id)
      .onSnapshot((snap) => {
        requests = snap.docs.map((doc) => ({
          id: doc.id,
          data: doc.data() as Request_v2
        }));
      });
  }

  async function getCompany(companyId: CompanyId) {
    firebase
      .firestore()
      .collection('companies_v1')
      .doc(companyId)
      .onSnapshot((doc) => {
        company = doc.data() as Company_v1;
      });
  }

  async function getContact(companyId: CompanyId) {
    await firebase
      .firestore()
      .collection('users_v1')
      .where('company', '==', companyId)
      .get()
      .then((snapshot) => {
        if (snapshot.docs.length > 0) {
          contact = {
            id: snapshot.docs[0].id,
            data: snapshot.docs[0].data() as User_v1
          };
        }
      });
  }

  function pauseOffer(pause: boolean) {
    firebase.functions().httpsCallable('api-offer-pauseoffer')({
      id,
      paused: pause
    });

    data.paused = pause;
  }

  async function saveTags() {
    await firebase
      .firestore()
      .collection("offers_v2")
      .doc(id)
      .set(data)
  }
</script>
